import React, { useState } from "react";
import ErrorText from "../ErrorText/ErrorText";
import styles from "../Input/Input.module.scss";
import { EyeCloseIcon, EyeIcon } from "../../../../assets/icons/svgicons";

const Password = ({ name, className, label, icon, formik, ...rest }) => {
	const [type, setType] = useState(true);
	return (
		<div className={`${styles.input} ${className || ""}`}>
			{label && <label htmlFor={name}>{label}</label>}
			<div className={`${styles.input_inner} ${styles.icon_input}`}>
				<input
					{...rest}
					name={name}
					isInvalid={formik?.touched[name] && formik?.errors[name] ? "" : null}
					id={name}
					type={type ? "password" : "text"}
				/>
				<span
					onClick={() => setType(!type)}
					className={`${styles.icon} ${type ? styles.close_eye : ""} ${formik?.touched[name] && formik?.errors[name] ? styles.warning_icon : ""} clickable`}
				>
					{type ? <EyeCloseIcon /> : <EyeIcon />}
				</span>
			</div>
			{formik?.touched[name] && formik?.errors[name] && (
				<ErrorText>{formik?.errors[name]}</ErrorText>
			)}
			{/* <ErrorMessage
                name={name}
                component={ErrorText}
            /> */}
		</div>
	);
};

export default Password;
